<div
  class="drawer"
  [ngClass]="{
    'drawer-open': open,
    'drawer-close': !open,
  }"
>
  <div (click)="doClose()">
    <img
      src="/assets/icons/drawer_x.svg"
      alt="Fechar"
    />
  </div>
  <div class="links">
    <div
      *ngFor="let link of links"
      (click)="navigate(link.link)"
      class="option"
    >
      <img [src]="link.icon" />
      <span>{{ link.name }}</span>
    </div>
  </div>
</div>

<div
  class="backdrop"
  (click)="doClose()"
  [ngClass]="{
    'backdrop-open': open,
    'backdrop-close': !open,
  }"
></div>
